import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        await api.post("/auth/session", { session_id: sessionId });
        await checkAuth();
        window.history.replaceState({}, document.title, "/");
        navigate("/");
      } catch (e) {
        setError("Autenticazione fallita. Riprova.");
        setTimeout(() => navigate("/login"), 2000);
      }
    })();
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0A0A0A] gap-4">
      <Loader2 className="h-8 w-8 animate-spin text-[#f98125]" />
      <p className="text-zinc-400">{error || "Accesso in corso..."}</p>
    </div>
  );
}

export function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <Loader2 className="h-8 w-8 animate-spin text-[#f98125]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function PendingScreen() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0A0A0A] gap-6 px-6 text-center">
      <div className="font-display text-5xl text-[#FF9500] tracking-tight">IN ATTESA</div>
      <p className="text-zinc-300 max-w-md">
        Ciao {user?.name}, il tuo account è in attesa di approvazione da parte di un amministratore.
        Riceverai accesso una volta accettato.
      </p>
      <button onClick={logout} data-testid="pending-logout-btn"
        className="rounded-sm border border-zinc-700 px-6 py-2 text-white hover:bg-zinc-800 transition-colors">
        Esci
      </button>
    </div>
  );
}
